<template>
  <form
    :class="formClasses"
    data-test-name="form"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </form>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@bigin/hooks'

const COMPONENT_NAME = 'BForm'

defineOptions({
  name: COMPONENT_NAME,
})

const ns = useNamespace('form')
const formClasses = computed(() => {
  return [ns.b()]
})
</script>
